const storageKey = (jobId) => `hiring_resume_import_${jobId}`;

export const loadImportState = (jobId) => {
  try {
    const raw = localStorage.getItem(storageKey(jobId));
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveImportState = (jobId, state) => {
  try {
    localStorage.setItem(storageKey(jobId), JSON.stringify(state));
  } catch {
    // ignore quota errors
  }
};

export const clearImportState = (jobId) => {
  try {
    localStorage.removeItem(storageKey(jobId));
  } catch {
    // ignore
  }
};

export const updateImportState = (jobId, updater) => {
  const current = loadImportState(jobId) || {
    sessionId: null,
    pendingCandidates: [],
    failedFiles: [],
    savedTempIds: [],
    counts: { NEEDS_REVIEW: 0, DUPLICATE: 0, FAILED: 0 },
  };
  const next = typeof updater === "function" ? updater(current) : { ...current, ...updater };
  saveImportState(jobId, next);
  return next;
};
